import { render } from "./InputSelect.vue?vue&type=template&id=8aeafb18"
import script from "./InputSelect.vue?vue&type=script&lang=js"
export * from "./InputSelect.vue?vue&type=script&lang=js"
script.render = render

export default script